import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { toastobj } from "../commonutilities";

const usePaymentStatus = (stripe, clientSecret, formSubmitted) => {
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchPaymentStatus = async () => {
      try {
        if (stripe && clientSecret && formSubmitted) {
          // Set loader to true when starting to fetch payment status
          setLoader(true);

          const { paymentIntent } = await stripe.retrievePaymentIntent(
            clientSecret
          );

          switch (paymentIntent.status) {
            case "succeeded":
              toast.success("Payment succeeded!", toastobj);
              break;
            case "processing":
              toast.info("Please wait, your payment is processing.", toastobj);
              break;
            case "requires_payment_method":
              /* toast.error(
                "Your payment was unsuccessful, please try again.",
                toastobj
              ); */
              break;
            case "requires_action":
            case "requires_source_action":
              // Handle additional actions if needed
              break;
            default:
              toast.error("Something went wrong.", toastobj);
              setError(true);
              break;
          }

          // Set loader back to false after fetching payment status
          setLoader(false);
        }
      } catch (error) {
        console.error("Error retrieving payment intent:", error);
        toast.error("Something went wrong.", toastobj);

        // Set loader back to false if there is an error
        setLoader(false);
      }
    };

    fetchPaymentStatus();
  }, [stripe, clientSecret, formSubmitted]);

  return { loader, error };
};

export default usePaymentStatus;
